import { useEffect, useState } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

/** undefined while loading; false when loaded and not admin. */
export function useIsAdmin(): boolean | undefined {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await identityApi.getBackstageIdentity();
        const baseUrl = await discoveryApi.getBaseUrl(
          'destroy-infrastructure',
        );
        const response = await fetchApi.fetch(`${baseUrl}/admin-status`);
        if (!response.ok) {
          if (!cancelled) {
            setIsAdmin(false);
          }
          return;
        }
        const body = (await response.json()) as { isAdmin?: boolean };
        if (!cancelled) {
          setIsAdmin(Boolean(body.isAdmin));
        }
      } catch {
        if (!cancelled) {
          setIsAdmin(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [discoveryApi, fetchApi, identityApi]);

  return isAdmin;
}
